import { createSlice } from "@reduxjs/toolkit";
import { getPlans } from "./_plansAction";

const initialState: any = {
  data: [],
  isLoading: true,
  isSuccess: false,
  responseCode: null,
  responseMessage: '',
  totalRecord: 0,
};

export const plansList = createSlice({
  name: "plans",
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getPlans.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
      })
      .addCase(getPlans.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = payload.data||[];
        state.responseMessage = payload.responseMessage
        state.responseCode = payload.responseCode
        state.totalRecord = payload.totalRecord || 0
      })
      .addCase(getPlans.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = payload;
      })
  },
});
